import { atom } from 'recoil';

export const selectedReceipt = atom({
  key: 'selectedReceipt',
  default: { image: '', id: '', amount: 0, category: '' },
});
